import React from "react";
import "./ContentForm.css";

const ContentForm = (props) => {
  return (
    <div className="cntnt-form mt-2">
      <div className="row justify-content-center">
        <div className="hdr-form">{props.headetText}</div>
      </div>
      <div className="row ml-0 mr-0">{props.children}</div>
    </div>
  );
};
export default ContentForm;
